/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentHistory from './treatment-history';
import TreatmentHistoryDetail from './treatment-history-detail';
import TreatmentHistoryUpdate from './treatment-history-update';
import TreatmentHistoryDeleteDialog from './treatment-history-delete-dialog';

const TreatmentHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentHistory />} />
    <Route path="new" element={<TreatmentHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentHistoryDetail />} />
      <Route path="edit" element={<TreatmentHistoryUpdate />} />
      <Route path="delete" element={<TreatmentHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentHistoryRoutes;
